<template>
  <div>
      <div class="main">
        <div class="preview">
            <h3>プレビュー</h3>
        </div>
        <div class="voice-container">
            <ul class="voice-states" v-bind:class="[avatarStyle]">
                <li class="voice-state"><img class="avatar color1 speaking" :src="imgPath" v-bind:class="[radiusStyle, animeStyle]">
                <div class="user">
                    <span class="name " v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User1</span>
                </div>
                </li>
                <li class="voice-state" v-bind:class="avatarStyle"><img class="avatar color2" :src="imgPath" v-bind:class="[radiusStyle, blightStyle]">
                <div class="user">
                    <span class="name" v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User2</span>
                </div>
                </li>
                <li class="voice-state" v-bind:class="avatarStyle"><img class="avatar color3" :src="imgPath" v-bind:class="[radiusStyle, blightStyle]">
                <div class="user">
                    <span class="name" v-bind:style="{background: colors.hex8}" v-bind:class="nameStyle">User3</span>
                </div>
                </li>
            </ul>
        </div>
        <div class="set">
          <h3>アイコンの大きさ</h3>
          <div class="radio-main">
            <label><input type="radio" value="dafaultavatar" v-model="avatarstyle" />デフォルト</label>
            <label><input type="radio" value="bigavatar" v-model="avatarstyle" />でかい</label>
            <label><input type="radio" value="sobigavatar" v-model="avatarstyle" />でっかい</label>
          </div>
          <h3>アイコンの形</h3>
          <div class="radio-main">
            <label><input type="radio" value="circle" v-model="radiusstyle" />まる</label>
            <label><input type="radio" value="radius" v-model="radiusstyle" />角まる</label>
            <label><input type="radio" value="square" v-model="radiusstyle" />四角</label>
          </div>
          <h3>名前の形</h3>
          <div class="radio-main">
            <label><input type="radio" value="defaultname" v-model="namestyle" />デフォルト</label>
            <label><input type="radio" value="circlename" v-model="namestyle" />角まる</label>
          </div>
          <h3>話している人のアニメーション</h3>
          <div class="radio-main">
            <label><input type="radio" value="defaulanime" v-model="animestyle" />デフォルト(緑のフチ取り)</label>
            <label><input type="radio" value="fuwafuwa" v-model="animestyle" />ふわふわ</label>
            <label><input type="radio" value="pyoko" v-model="animestyle" />ぴょこぴょこ</label>
          </div>
          <h3>名前のカラー選択</h3>
          <div class="radio-main">
            <chrome-picker :value="colors" v-model="colors"></chrome-picker>
          </div>
          <h3>コピペ用CSS</h3>
          <p>DiscordオーバレイのカスタムCSSです。</p>
          <p><a href="https://streamkit.discord.com/overlay" target="_blank" rel="noopener noreferrer">streamkit</a>でDiscordのボイスチャンネルのURLを取得→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
          <p>縦ならびにしたいときは、ブラウザソースの幅を小さくします。200とか。</p>
          <p><a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">さらに詳しい使い方はこちら</a></p>
          <div class="radio-main">
            <textarea id="target" readonly class="discord-form-text" v-model="resultCSS" />
            <button @click="copy" class="copy-btn">コピー</button>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      imgPath: require('@/assets/discord-icon.png'),
      radiusstyle: 'circle',
      animestyle: 'defaulanime',
      avatarstyle:'dafaultavatar',
      namestyle:'defaultname',
      colors: {
          hex: '#000000',
          hex8: '#000000FF',
          hsl: { h: 150, s: 0, l: 0, a: 1 },
          rgba: { r: 0, g: 0, b: 0, a: 1 },
          a: 1
      },
      importcss:':root {\n',
      namecolor:'--name-bg-color:',
      radiuscss : '--icon-radius:50%;\n',
      avatarcss:'--avatar-size:56px;\n',
      namecss:'--name-radius:3px;\n',
      screencss:'ul li{margin-top:30px;display: block;}',
      anime:'',
      nonanimeblight:'',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText("[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:var(--avatar-size);}[class*='Voice_avatar__']{width:var(--avatar-size);height:var(--avatar-size);border-radius:var(--icon-radius);filter:brightness(var(--staging-brightness));margin-bottom: 3px;}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(var(--speaking-brightness))!important;border-color:var(--trans)!important;}@keyframes fuwafuwa{0%{transform:translate(0,0)rotate(-5deg);}50%{transform:translate(0,-5px)rotate(0deg);}100%{transform:translate(0,0)rotate(5deg);}}@keyframes pyoko{0%{transform:translate(0,0)rotate(0deg);}50%{transform:translate(0,-10px)rotate(0deg);}100%{transform:translate(0,0)rotate(0deg);}}[class*='Voice_name__']{text-align:center;width:var(--avatar-size);background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:17px;border-radius:var(--name-radius);padding:2px 0px!important;margin-right:2px;margin-left:4px;box-sizing:border-box;overflow:hidden;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" +this.importcss +this.avatarcss + this.namecolor + this.colors.hex8 + ";\n" + this.radiuscss + this.namecss + this.anime + this.nonanimeblight + "}\n" + this.screencss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },

    setRadiusCss: function(){
        switch(this.radiusstyle){
            case 'radius':
                this.radiuscss = '--icon-radius:38%;\n'
                break;
            case 'circle':
                this.radiuscss = '--icon-radius:50%;\n'
                break;
            case 'square':
                this.radiuscss = '--icon-radius:0%;\n'
                break;
        }
    },
    setAvatarCss: function(){
        switch(this.avatarstyle){
            case 'dafaultavatar':
                this.avatarcss = '--avatar-size:56px;\n'
                break;
            case 'bigavatar':
                this.avatarcss = '--avatar-size:72px;\n'
                break;
            case 'sobigavatar':
                this.avatarcss = '--avatar-size:96px;\n'
                break;
        }
    },
    setNameCss: function(){
      switch(this.namestyle){
            case 'defaultname':
                this.namecss = '--name-radius:3px;\n'
                break;
            case 'circlename':
                this.namecss = '--name-radius:18px;\n'
                break;
        }
    },
    setAnimeCss: function(){
        switch(this.animestyle){
            case 'defaulanime':
                this.anime = ''
                this.nonanimeblight= ''
                break;
            case 'fuwafuwa':
                this.anime = '--speaking-anime:fuwafuwa 300ms infinite linear alternate;\n--speaking-brightness:100%;\n--trans:transparent;\n'
                this.nonanimeblight= '--staging-brightness:70%;\n'
                break;
            case 'pyoko':
                this.anime = '--speaking-anime:pyoko 300ms infinite linear alternate;\n--speaking-brightness:100%;\n--trans:transparent;\n'
                this.nonanimeblight= '--staging-brightness:70%;\n'
                break;
        }
    },
  },
  watch:{
    radiusstyle:function(){
        this.setRadiusCss()
    },
    avatarstyle:function(){
        this.setAvatarCss()
    },
    namestyle:function(){
        this.setNameCss()
    },
    animestyle:function(){
        this.setAnimeCss()
    },
  },
  computed: {
    resultCSS(){
        return "[class*='Voice_voiceStates__']{list-style-type:none;padding-left:15px;display:flex;flex-wrap:wrap;}[class*='Voice_voiceState__']{height:var(--avatar-size);}[class*='Voice_avatar__']{width:var(--avatar-size);height:var(--avatar-size);border-radius:var(--icon-radius);filter:brightness(var(--staging-brightness));margin-bottom: 3px;}[class*='Voice_avatarSpeaking__']{animation:var(--speaking-anime);filter:brightness(var(--speaking-brightness))!important;border-color:var(--trans)!important;}@keyframes fuwafuwa{0%{transform:translate(0,0)rotate(-5deg);}50%{transform:translate(0,-5px)rotate(0deg);}100%{transform:translate(0,0)rotate(5deg);}}@keyframes pyoko{0%{transform:translate(0,0)rotate(0deg);}50%{transform:translate(0,-10px)rotate(0deg);}100%{transform:translate(0,0)rotate(0deg);}}[class*='Voice_name__']{text-align:center;width:var(--avatar-size);background-color:var(--name-bg-color)!important;opacity:var(--name-opacity)!important;font-size:12px!important;border-radius:var(--name-radius);padding:2px 0px!important;margin-right:2px;margin-left:4px;box-sizing:border-box;overflow:hidden;display:block;}[class*='Voice_name__']{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}\n" + this.importcss + this.avatarcss + this.namecolor + this.colors.hex8 + ";\n" + this.radiuscss + this.namecss + this.anime + this.nonanimeblight + "}\n"  + this.screencss;
    },
    radiusStyle: function() {
      if (this.radiusstyle === 'radius') {
        return 'avatar-radius';
      }
      else if (this.radiusstyle === 'circle') {
        return 'avatar-circle';
      }
      else {
        return 'avatar-square';
      }
    },
    avatarStyle: function() {
      if (this.avatarstyle === 'dafaultavatar') {
        return 'avatar-size1';
      }
      else if (this.avatarstyle === 'bigavatar') {
        return 'avatar-size2';
      }
      else {
        return 'avatar-size3';
      }
    },
    nameStyle: function(){
      if (this.namestyle === 'defaultname') {
        return 'name-radius1';
      }
      else if (this.namestyle === 'circlename') {
        return 'name-radius2';
      }
      else {
        return '';
      }
    },
    animeStyle: function() {
      if (this.animestyle === 'pyoko') {
        return 'pyoko';
      }
      else if (this.animestyle === 'fuwafuwa') {
        return 'fuwafuwa';
      }
      else {
        return '';
      }
    },
    blightStyle: function() {
      if (this.animestyle === 'defaulanime') {
        return '';
      }
      else {
        return 'brightness';
      }
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 767px;
  margin: 0 auto;
}

.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #FFFEF9;
  border-radius: 10px;
}

/* プレビューエリア */
.preview{
    padding: 2px 12px;
}

.voice-container{
  margin-bottom: 48px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #fff;
}

.voice-states{
    list-style-type: none;
    padding-left: 15px;
    display: flex;
  margin-bottom: 3px;
}

.voice-container .voice-states .voice-state {
  height: var(--avatar-size);
  margin-bottom: 5px;
}

ul {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}

li {
    display: list-item;
    text-align: -webkit-match-parent;
    vertical-align: middle;
}

.voice-container .voice-states .voice-state .avatar {
    border: 3px solid transparent;
    float: left;
    margin-right: 14px;
    margin-bottom:5px;
    object-fit: scale-down;
    padding: 5px;
    box-sizing:border-box;
    height: var(--avatar-size);
    width: var(--avatar-size);
}

.speaking{
  border-color: #43b581 !important;
}

.fuwafuwa {
  animation:fuwafuwa 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}

@keyframes fuwafuwa {
  0% {transform:translate(0, 0) rotate(-5deg);}
  50% {transform:translate(0, -5px) rotate(0deg);}
  100% {transform:translate(0, 0)rotate(5deg);}
}

.pyoko {
  animation:pyoko 300ms infinite linear alternate;
  filter: brightness(100%);
  border-color: transparent!important;
}

@keyframes pyoko {
    0% {transform:translate(0, 0) rotate(0deg);}
    50% {transform:translate(0, -10px) rotate(0deg);}
    100% {transform:translate(0, 0)rotate(0deg);}
}

.brightness{
  filter: brightness(70%);
}

.color1{
  background-color: blue;
}

.color2{
  background-color: lightcoral;
}

.color3{
  background-color: lightgreen;
}

.avatar-radius{
  border-radius: 38%;
}

.avatar-circle{
  border-radius: 50%;
}

.avatar-square{
  border-radius: 0%;
}

.avatar-size1{
  --avatar-size:56px;
  --ff:56px;
}

.avatar-size2{
   --avatar-size:72px;
   --ff:72px;
}

.avatar-size3{
   --avatar-size:96px;
}

.name-radius1{
  --name-radius:3px;
}

.name-radius2{
  --name-radius:18px;
}

.voice-container .voice-states .voice-state .user {
    padding-top: calc(var(--avatar-size)/3);
}

.voice-container .voice-states .voice-state .user .name {
    text-align: center;
    max-width: var(--avatar-size);
    background-color: #1e2124;
    color:white;
    font-size: 12px;
    padding: 4px 6px;

    box-sizing: border-box;
    overflow: hidden;
    display: block;
}

.name{
  border-radius:var(--name-radius);
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}

.radio-main label{
  margin-right: 8px;
}

.discord-form-text{
    width: 60%;
  height: 80px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}

</style>